import { motion } from 'framer-motion';
import { FiChevronRight, FiCheckCircle } from 'react-icons/fi';

export default function CoachingPromoSection() {
  return (
    <section style={{
      position: 'relative',
      padding: '6rem 1.5rem',
      backgroundColor: '#05050f',
      overflow: 'hidden',
      borderTop: '1px solid rgba(168, 85, 247, 0.2)',
      borderBottom: '1px solid rgba(168, 85, 247, 0.2)',
      marginTop: '4rem',
      marginBottom: '4rem'
    }}>
      {/* Background Glows */}
      <div style={{
        position: 'absolute',
        top: '0',
        right: '0',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(168,85,247,0.1) 0%, rgba(0,0,0,0) 70%)',
        filter: 'blur(80px)',
        zIndex: 0,
      }} />
      <div style={{
        position: 'absolute',
        bottom: '0',
        left: '0',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(99,102,241,0.1) 0%, rgba(0,0,0,0) 70%)',
        filter: 'blur(80px)',
        zIndex: 0,
      }} />

      <div style={{
        position: 'relative',
        zIndex: 1,
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
        gap: '4rem',
        alignItems: 'center'
      }}>
        
        {/* Left Side: Copy & CTA */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
        >
          <div style={{
            display: 'inline-block',
            padding: '0.5rem 1rem',
            background: 'rgba(99, 102, 241, 0.1)',
            border: '1px solid rgba(99, 102, 241, 0.2)',
            borderRadius: '999px',
            color: '#818cf8',
            fontSize: '0.875rem',
            fontWeight: '600',
            marginBottom: '1.5rem',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}>
            Yelken x Eksen Studio 🎓
          </div>
          
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: '900',
            lineHeight: '1.2',
            color: '#fff',
            marginBottom: '1.5rem',
            letterSpacing: '-1px'
          }}>
            Masada Tek Başına <br/>
            <span style={{
              background: 'linear-gradient(135deg, #a855f7, #6366f1)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}>Kriz Geçirme Devri Bitti.</span>
          </h2>
          
          <p style={{
            color: '#94a3b8',
            fontSize: '1.1rem',
            lineHeight: '1.6',
            marginBottom: '2rem'
          }}>
            Sadece ders çalışmak yetmez, stratejik çalışmak gerekir. Türkiye derecesi yapmış akran koçlarımızla tanış, haftalık sana özel programını Yelken platformundan takip et ve rakiplerini geride bırak.
          </p>

          <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 2.5rem 0', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {[
              "Sana Özel Hazırlanmış Günlük Görevler",
              "Hocadan Değil, Dersi AA ile Geçen Akranından Taktikler",
              "Piyasanın 3'te 1 Fiyatına Premium Koçluk"
            ].map((item, i) => (
              <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', color: '#cbd5e1', fontSize: '1rem', fontWeight: '500' }}>
                <FiCheckCircle size={20} color="#a855f7" />
                {item}
              </li>
            ))}
          </ul>

          <motion.button
            whileHover={{ scale: 1.05, boxShadow: '0 0 30px rgba(168,85,247,0.4)' }}
            whileTap={{ scale: 0.95 }}
            onClick={() => window.open('https://eksen.studio/', '_blank')}
            style={{
              background: 'linear-gradient(135deg, #7e22ce, #4f46e5)',
              color: '#fff',
              border: 'none',
              padding: '1.2rem 2.5rem',
              fontSize: '1.1rem',
              fontWeight: '700',
              borderRadius: '999px',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '12px',
              boxShadow: '0 10px 25px -5px rgba(126, 34, 206, 0.3)',
            }}
          >
            Koçluk Sistemini İncele <FiChevronRight size={20} />
          </motion.button>
        </motion.div>

        {/* Right Side: Visual / Glassmorphism Dashboard Peek */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.2 }}
          style={{ position: 'relative' }}
        >
          <div style={{
            background: 'rgba(15, 23, 42, 0.6)',
            border: '1px solid rgba(255, 255, 255, 0.05)',
            borderRadius: '24px',
            padding: '2rem',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: '0 20px 40px rgba(0,0,0,0.4)'
          }}>
            {/* Fake Dashboard Elements */}
            <div style={{ opacity: 0.8, pointerEvents: 'none', userSelect: 'none' }}>
              <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem' }}>
                <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'linear-gradient(135deg, #a855f7, #6366f1)' }}></div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <div style={{ width: '100px', height: '14px', background: '#334155', borderRadius: '4px', marginBottom: '8px' }}></div>
                  <div style={{ width: '160px', height: '10px', background: '#1e293b', borderRadius: '4px' }}></div>
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {[
                  { title: "TYT Matematik - Problem Kampı", sub: "Matematik • 90 dk", color: "#6366f1" },
                  { title: "Paragraf Denemesi (20 Soru)", sub: "Türkçe • 30 dk", color: "#f43f5e" },
                  { title: "Koç ile Haftalık Değerlendirme", sub: "Görüşme • 45 dk", color: "#10b981" }
                ].map((item, i) => (
                  <div key={i} style={{ 
                    background: 'rgba(255,255,255,0.03)', 
                    borderRadius: '12px', 
                    padding: '1.25rem', 
                    borderLeft: `4px solid ${item.color}` 
                  }}>
                    <div style={{ fontSize: '1rem', color: '#f8fafc', fontWeight: '600', marginBottom: '6px' }}>{item.title}</div>
                    <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{item.sub}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Glowing Lock Overlay */}
            <div style={{
              position: 'absolute',
              bottom: '-20px',
              right: '-20px',
              width: '120px',
              height: '120px',
              background: 'rgba(168, 85, 247, 0.1)',
              filter: 'blur(30px)',
            }} />
          </div>
        </motion.div>

      </div>
    </section>
  );
}
